import appendSlide from './appendSlide';
import prependSlide from './prependSlide';
import addSlide from './addSlide';
import removeSlide from './removeSlide';
import removeAllSlides from './removeAllSlides';

export default {
  appendSlide,
  prependSlide,
  addSlide,
  removeSlide,
  removeAllSlides,
};
